// import reverbEdit from "./edit.vue";
import water_comment_list from "./list.vue";
// import reverbInfo from "./info.vue";
let a = Object.assign({ water_comment_list });
export default a;
